import { $, on, addClass, removeClass } from "@olmokit/dom";
import BaseHeader from "@olmokit/components/Header";
import { scrollThreshold } from "@olmokit/core/scroll/threshold";
import scrollLock from "@olmokit/core/scroll/lock";
import "components/Menu";

import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import "./index.scss";

/**
 * Component: Header
 *
 */
export function Header() {
  const header = BaseHeader();

  scrollThreshold(1, { target: header.$root });

  const openmenu = $('.Header:openmenu');
  const menu = $('.Menu:');
  const bgmenu = $('.Menu:bg');
  const closemenu = $('.Menu:closemenu');
  on(openmenu, 'click', (e) => {
    if (!e.target.classList.contains('is-in')) {
      openMenu(bgmenu, menu);
    } else {
      closeMenu(bgmenu, menu);
    }
  });
  on(bgmenu, 'click', (e) => {
    closeMenu(bgmenu, menu);
  });
  on(closemenu, 'click', (e) => {
    closeMenu(bgmenu, menu);
  });
  document.addEventListener('keydown', evt => {
    if (evt.key === 'Escape') {
      closeMenu(bgmenu, menu);
    }
  });

  return {
    /**
     * Set variant
     *
     * @param {"light" | "dark"} variant
     */
    setVariant(variant) {
      const { className } = header.$root;
      header.$root.className = className.replace(
        /(is-).+(\s*)/,
        `$1${variant}$2`
      );
    },
  };

}

// Flyout menu functions
function openMenu(bg, container) {
  scrollLock.disable(document.body);
  addClass(bg, "is-in");
  addClass(container, "is-in");
}
function closeMenu(bg, container) {
  scrollLock.enable(document.body);
  removeClass(bg, "is-in");
  setTimeout(() => {
    removeClass(container, "is-in");
  }, 900);
}
